import { getCompatibleAuthTokenHttp } from 'src/services/utils/enhancedAuthTokenHttp';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';

export interface CrossValidatorGlobal {
  name: string;
  value: string;
  confidence: number;
}

interface CrossValidatorGlobalsMapping {
  id: string;
  type: string;
  mapping: {
    globals?: CrossValidatorGlobal[];
  };
}

interface GetCrossValidatorGlobalsResponse {
  success: boolean;
  loanMappings: CrossValidatorGlobalsMapping[];
}

const CROSS_VALIDATOR_GLOBALS_TYPE = 'Cross-Validator-Globals';

const getCrossValidatorGlobals: QueryFunction<
  CrossValidatorGlobal[],
  ['/loans', string, 'cross-validator-globals']
> = async ({ queryKey }) => {
  if (isMockServices()) return await mock(_mockData);

  const loanId = queryKey[1];
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const url = `/loans/${loanId}/loan-mappings?type=${encodeURIComponent(
    CROSS_VALIDATOR_GLOBALS_TYPE,
  )}`;
  const response = await authTokenHttp<GetCrossValidatorGlobalsResponse>(url, {
    method: 'GET',
  });

  if (response.data) {
    return response.data.loanMappings.flatMap(
      (loanMapping) => loanMapping.mapping.globals ?? [],
    );
  }
  throw new Error('Failed to fetch cross-validator globals');
};

export default getCrossValidatorGlobals;

const _mockData: CrossValidatorGlobal[] = [
  { name: 'Borrower First Name', value: 'LISA', confidence: 200 },
  { name: 'Borrower Middle Name', value: '', confidence: 200 },
];
